// apiConfig.js
const API_CONFIG2 = {
    apiUrl: 'https://app.bisenter-rdc.com/',
  };
  
  export default API_CONFIG2;
 